import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FamiliaequipoService } from '@/app/services/familiaequipo.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-editar-familiaequipo',
    templateUrl: './editar-familiaequipo.component.html',
    styleUrls: ['./editar-familiaequipo.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditarFamiliaequipoComponent {
  private spinner = inject(NgxSpinnerService);

  //Model
  familiaRQ = {
    idFamiliaEquipo: null,
    descripcion: null,
    valor: null,
    activo: true,
  };

  //bandera global para cerrar el modal
  hasFinished: boolean = false;

  constructor(
    private familiaEquipoService: FamiliaequipoService,
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<EditarFamiliaequipoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

    let {
      idFamiliaEquipo,
      descripcion,
      valor,
      activo
    } = data;

    this.familiaRQ.idFamiliaEquipo = idFamiliaEquipo;
    this.familiaRQ.descripcion = descripcion;
    this.familiaRQ.valor = valor;
    this.familiaRQ.activo = activo;

    //console.log(this.familiaRQ);
  }

  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas actualizar esta familia?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.updateFamilia();
        }
      });
    }
  }

  updateFamilia(){
    this.spinner.show();

    //Pendiente: asignar creao por desde token
    //this.UsuarioRQ.creadoPor = 'TO-DO';

    this.familiaEquipoService.updateFamilia(this.familiaRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Familia actualizado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se han guardado los cambios. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }
}
